import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule, NumericTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { InputCaptchaComponent } from './input-captcha/input-captcha.component';
import { InputEmailComponent } from './input-email/input-email.component';
import { InputErrorComponent } from './input-error/input-error.component';
import { InputPasswordComponent } from './input-password/input-password.component';
import { InputSmsComponent } from './input-sms/input-sms.component';
import { InputTextComponent } from './input-text/input-text.component';
import { SharedModule } from '../shared.module';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    ButtonsModule,
    NumericTextBoxModule,
    NumericTextBoxModule,
    TextBoxModule,
    InputsModule,
  ],
  declarations: [
    InputEmailComponent,
    InputPasswordComponent,
    InputSmsComponent,
    InputErrorComponent,
    InputCaptchaComponent,
    InputTextComponent,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    NumericTextBoxModule,
    NumericTextBoxModule,
    TextBoxModule,
    ButtonsModule,
    InputEmailComponent,
    InputPasswordComponent,
    InputSmsComponent,
    InputErrorComponent,
    InputCaptchaComponent,
    InputTextComponent,
  ],
})
export class FormModule {
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/form.module.ts